import { radioAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  radioAnatomy.keys
);

export default defineMultiStyleConfig({
  baseStyle: ({ colorScheme }) => ({
    control: {
      _checked: {
        bg: `${colorScheme}.600`,
        borderColor: `${colorScheme}.600`,
        _hover: {
          bg: `${colorScheme}.500`,
          borderColor: `${colorScheme}.500`,
        },
        _active: {
          bg: `${colorScheme}.700`,
          borderColor: `${colorScheme}.700`,
        },
      },
    },
    label: {
      color: "gray.800",
    },
  }),
  variants: {
    padded: ({ size }) => ({
      container: {
        _before: {
          content: `""`,
          w: "100%",
        },
        minH:
          size === "lg"
            ? "12"
            : size === "md"
            ? "10"
            : size === "sm"
            ? "9"
            : undefined,
        alignItems: "start",
        flexWrap: "wrap",
      },
      control: {
        mx:
          size === "lg"
            ? "3.5"
            : size === "md"
            ? "2.5"
            : size === "sm"
            ? "2"
            : undefined,
        mt:
          size === "lg"
            ? "0.5"
            : size === "md"
            ? "1"
            : size === "sm"
            ? "0.5"
            : undefined,
      },
      label: {
        ml: 0,
        flex: "1",
      },
    }),
  },
  sizes: {
    lg: {
      control: {
        boxSize: "5",
      },
      label: {
        fontSize: "lg",
      },
    },
    md: {
      control: {
        boxSize: "5",
      },
      label: {
        fontSize: "md",
      },
    },
    sm: {
      control: {
        boxSize: "4",
      },
      label: {
        fontSize: "md",
      },
    },
    prismMd: {
      container: {
        my: "10px",
        ml: "10px",
      },
      control: {
        boxSize: 5,
      },
      label: {
        fontSize: "sm",
        lineHeight: "20px",
      },
    },
  },
});
